module.exports = __webpack_public_path__ + "images/82d54f45e646f87f89b3fa9dc2f54a5a.svg";